<template>
  <div class="app-page">
    <PageHeader type="back" />
    <a-modal v-model:visible="open" :closable="false" :keyboard="false" :maskClosable="false" :footer="null" width="800px" wrap-class-name="full-modal">
      <p v-if="isEn" class="modal-title">Young Talent Attention Please!</p>
      <p v-else class="modal-title">潜力狮请注意！</p>
      <div class="modal-content" v-if="isEn">
          <p class="modal-subtitle">Please prepare accordingly based on the communication email for the current session.</p>
          <p class="modal-subtitle underline">If this is an <span class="current"> [online application] </span>session：</p>
        <p class="modal-text closer">
          Please ensure that you select your
          <span class="current">[current]</span>
          brand, role and level,<br/>
          to review the corresponding career guide,
        </p>
        <p class="modal-text closer">
          complete the required courses and certifications within the specified timeframe，
        </p>
        <p class="modal-text closer">
            and meet the qualification requirements；
        </p>
        <p class="modal-text closer">otherwise the online application could not be submitted.</p>
        <br/>
        <p class="modal-subtitle underline">If this is a <span class="current"> [non-online application] </span>session：</p>

        <p class="modal-text closer">
             You may still refer to the career guide to check the qualifications，<br/>
             access the learning resources, plan your development path，<br/>
             and keep upskilling yourself.
        </p>
        <br/>


        <p class="modal-text closer">If you have any questions regarding the specific role or level options，<br/>
        please confirm with your HRBP first. Thank you！</p>
        <button :class="{ 'modal-button': true, 'can-click': canClick }" @click="hideModal">
          I acknowledge
          <span v-if="!canClick">({{ countDown }}s)</span>
        </button>
      </div>
      <div class="modal-content" v-else>
          <p class="modal-subtitle">请您根据出狮行动当前轮次的沟通邮件，相应进行筹备</p>

          <p class="modal-subtitle underline">若为<span class="current"> [线上申请] </span>轮次：</p>
          <p class="modal-text closer">
          请务必选择自己
          <span class="current">[当前]</span>
          所处的品牌、角色、职级，
          查看对应的发展指南，
        </p>
        <p class="modal-text closer">
          在规定时间前完成
          <span class="current">[当前]</span>
          角色职级所要求的培训或考证，
        </p>
        <p class="modal-text">
          达到
          <span class="current">[当前]</span>
          角色职级的能力要求，否则将无法提交线上申请。
        </p>
        <p class="modal-subtitle underline">若为<span class="current"> [非线上申请] </span>轮次：</p>

         <p class="modal-text">
            您依然可以在此处查看发展指南，了解能力要求，获取学习资源，<br/>规划发展路径，持续提升自我。
        </p>
        <p class="modal-text">如您对角色职级的具体选项有疑问，请先与您的HRBP沟通确认，谢谢！</p>
        <button :class="{ 'modal-button': true, 'can-click': canClick }" @click="hideModal">
          我已知晓
          <span v-if="!canClick">（{{ countDown }}秒）</span>
        </button>
      </div>
    </a-modal>

    <div class="application-page-container">
      <div class="search-form">
        <a-form layout="inline" :model="searchForm" @finish="handleFinish">
          <div class="flex">
            <a-form-item :label="$t('user.Role:')">
              <a-select ref="select" v-model:value="searchForm.agency" :placeholder="$t('user.Brand')" @change="agencyHandleChange">
                <a-select-option v-for="agency in agencyOptions" :key="agency" :value="agency">
                  {{ agency }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select ref="select" v-model:value="searchForm.role" :placeholder="$t('user.Role')" @change="roleHandleChange">
                <a-select-option v-for="role in roleOptions" :key="role" :value="role">
                  {{ role }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select ref="select" v-model:value="searchForm.level" :placeholder="$t('user.Level')" @change="levelHandleChange" dropdownMatchSelectWidth="false" class="level-select">
                <a-select-option v-for="level in levelOptions" :key="level.key" :value="level.key">
                  {{ level.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </a-form>
        <div style="font-weight: initial !important; font-size: 12px; padding-top: 8px">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</div>
      </div>
      <div class="job-info">
        <div class="info-left">
          <div class="jinfo-theme" v-if="jobInfo.theme">
            <span>{{ $t('user.Theme') }}:</span>
            {{ jobInfo.theme }}
          </div>
          <div :class="`jinfo-header ${jobInfo.theme != null ? 'msg' : 'default'}`">
            <div class="jinfo-title">
              {{ $t('user.Job Qualifications') }}
              <!-- <span style="font-weight: initial; margin-left: 8px">
                *The highlighted items show the key difference between this
                level and one level down.
              </span> -->
            </div>
          </div>
          <template v-if="jobInfo.jobQualifications.length === 0">
            <div class="jinfo-content default">
              {{ $t('user.Please select role to see job qualification list.') }}
            </div>
          </template>
          <template v-else>
            <ul class="qualification-list">
              <li v-for="qua in jobInfo.jobQualifications" :class="qua.style" :key="qua.key">
                {{ qua.value }}
              </li>
            </ul>
          </template>
        </div>
        <div class="info-right">
          <div class="jinfo-header">
            <div class="jinfo-title">{{ $t('user.Learning Resources') }}</div>
            <div style="font-size: 14px">
              *
              {{ $t('user.You can click on the link to enroll directly. For course without link, please contact your HRBP for nomination.') }}
            </div>
            <div style="font-size: 14px; word-break: break-word">
              *
              {{ $t('user.If you have any questions about learning, please contact') }}
              PG_China_Academy_PUB_CN@publicisgroupe.net
            </div>
          </div>
          <div class="jinfo-content default" v-if="jobInfo.resources == null">
            {{ $t('user.Please select role to see learning resources.') }}
          </div>
          <div class="jinfo-content list" v-else>
            <div class="jinfo-content title">
              <strong>{{ $t('user.Mandatory') }}</strong>
            </div>
            <template v-for="(doc, idx) in jobInfo.docs" :key="idx">
              <template v-if="doc.type == 'doc' || doc.type == 'doc_highlight'">
                <a
                  :style="{
                    display: 'block',
                    color: doc.type == 'doc' ? 'inherit' : '#AC7F40',
                    textDecoration: 'underline',
                  }"
                  target="_blank"
                  v-if="jobInfo.links[doc.f.toLocaleLowerCase()]"
                  :href="jobInfo.links[doc.f.toLocaleLowerCase()]['link']"
                >
                  <span>{{ doc.f }}</span>
                </a>
                <span
                  :style="{
                    display: 'block',
                    marginBottom: '5px',
                    color: doc.type == 'doc' ? 'inherit' : '#AC7F40',
                  }"
                  v-else
                >
                  {{ doc.f }}
                </span>
              </template>
            </template>
            <div v-if="jobInfo.docs_optional.length > 0" style="padding-bottom: 14px">
              <br />
              <strong>{{ $t('user.Optional') }}</strong>
            </div>
            <template v-for="(doc, idx) in jobInfo.docs_optional" :key="idx">
              <template v-if="doc.type == 'doc' || doc.type == 'doc_highlight'">
                <a
                  :style="{
                    display: 'block',
                    color: doc.type == 'doc' ? 'inherit' : '#AC7F40',
                    textDecoration: 'underline',
                  }"
                  target="_blank"
                  v-if="jobInfo.links[doc.f.toLocaleLowerCase()]"
                  :href="jobInfo.links[doc.f.toLocaleLowerCase()]['link']"
                >
                  <span>{{ doc.f }}</span>
                </a>
                <span
                  :style="{
                    display: 'block',
                    marginBottom: '5px',
                    color: doc.type == 'doc' ? 'inherit' : '#AC7F40',
                  }"
                  v-else
                >
                  {{ doc.f }}
                </span>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Modal } from 'ant-design-vue'
  import i18n from '../../locales'
  import PageHeader from '@/components/PageHeader.vue'
  import { getAgencyOptions, getRoleOptions, getTargetLevelOptions } from '@/api/dict'
  import { getJobQualificationsWithLink } from '@/api/index'
  import avators from '@/assets/avator'
  export default {
    name: 'Index',
    components: { PageHeader },
    computed: {
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
    data() {
      return {
        searchForm: {
          agency: undefined,
          role: undefined,
          level: undefined,
        },
        jobInfo: {
          agency: null,
          id: null,
          level: null,
          resources: null,
          theme: null,
          jobQualifications: [],
        },
        learningMsg: null,
        agencyOptions: [],
        roleOptions: [],
        levelOptions: [],
        open: false,
        canClick: false,
        countDown: 20,
      }
    },
    mounted() {
      this.open = true
      const that = this
      const intv = setInterval(() => {
        if (that.countDown < 1) {
          clearInterval(intv)
          that.canClick = true
        } else {
          that.countDown = that.countDown - 1
        }
      }, 1000)
      getAgencyOptions().then((res) => {
        if (res.code == 200) {
          this.agencyOptions = res.data
        }
      })
    },
    methods: {
      hideModal() {
        if (this.canClick) {
          this.open = false
        }
      },
      setSilderAvator(rolename) {
        const filename = rolename.toLocaleLowerCase().replace(/\s*/g, '')
        this.$store.dispatch('user/setAvator', avators[filename])
      },
      agencyHandleChange(value) {
        this.searchForm.role = null
        this.searchForm.level = null
        this.jobInfo = {
          agency: null,
          id: null,
          level: null,
          resources: null,
          theme: null,
          jobQualifications: [],
        }
        getRoleOptions(value).then((res) => {
          if (res.code == 200) {
            this.roleOptions = res.data
          }
        })
      },
      roleHandleChange(value) {
        this.searchForm.level = null
        this.jobInfo = {
          agency: null,
          id: null,
          level: null,
          resources: null,
          theme: null,
          jobQualifications: [],
        }
        getTargetLevelOptions(this.searchForm.agency, value).then((res) => {
          if (res.code == 200) {
            this.levelOptions = res.data
          }
        })
      },
      levelHandleChange(value) {
        this.handleFinish()
      },
      handleFinish() {
        this.setSilderAvator(this.searchForm.role)
        getJobQualificationsWithLink(this.searchForm.level).then((res) => {
          if (res.code == 200) {
            this.jobInfo = res.data
            this.jobInfo.jobQualifications = res.data.items
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');

  .application-page-container {
    margin: @app-conetent-margin;
  }

  .search-form {
    padding: 20px 24px;
    background-color: white;
    margin-bottom: 16px;

    .flex {
      display: flex;
    }
    .ant-form-item-label > label {
      font-weight: bolder !important;
    }

    .ant-select {
      width: 20vw;
    }
    .level-select {
      width: 33vw;
    }

    :deep label {
      font-weight: bold;
    }
  }

  .job-info {
    display: flex;
    min-height: 530px;

    .info-left {
      background-color: white;
      flex-grow: 7;
      width: 70%;
      margin-right: 16px;
    }

    .info-right {
      background-color: white;
      flex-grow: 3;
      width: 30%;
    }

    .jinfo-theme {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-weight: 700;
      padding: 16px 24px;
    }

    .qualification-list {
      list-style: none;
      padding-left: 40px;

      li {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 42px;
        font-weight: 400;

        &.high {
          color: @primary-color;
        }
      }
    }

    .jinfo-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;

      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }

      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    .jinfo-content {
      padding: 0px 24px;
      white-space: pre-line;

      &.list {
        padding: 16px 24px;
      }

      &.default {
        padding: 14px 24px;
      }

      &.title {
        padding: 0 0 8px 0;
      }

      a {
        margin-bottom: 5px;
      }
    }
  }

  .scaffolding-box {
    height: 900px;
    width: 100%;

    &:nth-child(1) {
      background-color: rgb(230, 230, 118);
    }

    &:nth-child(2) {
      background-color: rgb(131, 236, 149);
    }

    &:nth-child(3) {
      background-color: rgb(115, 128, 241);
    }
  }

  .modal-title {
    color: #ac4040;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }
  .modal-subtitle {
    color: #333;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
  .modal-text {
    color: #333;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
  }
  .current {
    color: #ac7f40;
    font-size: 18px;
    font-weight: 600;
  }
  .underline {
    text-decoration: underline;
  }
  .closer {
    margin-bottom: .2em
  }

  .modal-content {
    text-align: center;
  }
  .modal-button {
    font-size: 18px;
    width: 280px;
    height: 48px;
    border-radius: 2px;
    background: #999;
    outline: none;
    border: none;
    color: #fff;
    margin: 0 auto;
    margin-top: 40px;
    &.can-click {
      cursor: pointer;
      background: #ac7f40;
    }
  }
</style>
